import React from "react";
import styles from "./index.module.scss";
import { dateMonthFormat } from "../../../../../../../utils/utils";
import moment from "moment";
import CallRecordsDialog from "../../../../../../../pages/calling-pipeline/call-records";
// import { useDeleteCallRecords } from "../../../../../../../hooks/react-query/investor-dashboard/useDeleteCallRecords";
// import { useToast } from "../../../../../toast/toast";

export default function CallRecordsItem({ item }: any) {
  const [visibleCallRecords, setVisibleCallRecords] = React.useState(false);
  // const { showSuccess }: any = useToast();
  // const deleteCallRecordsMutation = useDeleteCallRecords(
  //   (data) => {
  //     showSuccess("success", "Call Record Deleted Successfully.");
  //     console.log("data", data);
  //   },
  //   (error) => {
  //     console.log("error", error);
  //   }
  // );

  return (
    <div className={styles.callRecordsItem}>
      <div className={styles.callBox}>
        <div className={styles.callBoxWrap}>
          <span className={styles.userName}>{item.contactname}</span>
          <span>Call-Recorded</span>
          {item?.followupdate && (
            <>
              {moment.utc(item?.followupdate).local().isBefore(moment()) ? (
                <span className={styles.followupDue}>Follow-up Due</span>
              ) : (
                <span className={styles.followupScheduled}>
                  Follow-up Scheduled
                </span>
              )}
            </>
          )}
          {item?.followupdate && (
            <>
              <span className={styles.dot}></span>
              <img src="/images/cal-history.svg" alt="calendar" />
              <span>{dateMonthFormat(item.followupdate)}</span>
            </>
          )}
        </div>
        <span className={styles.actions}>
          <img
            src="/images/edit.svg"
            alt=""
            width={20}
            onClick={() => setVisibleCallRecords(true)}
          />
          {/* <img
            src="/images/delete.svg"
            alt=""
            onClick={() => deleteCallRecordsMutation.mutate(item?.id)}
          /> */}
        </span>
        <CallRecordsDialog
          visible={visibleCallRecords}
          setVisible={setVisibleCallRecords}
          accountId={item?.accountId}
          propertyId={item?.propertyId}
          checkoutId={item?.checkoutId}
          item={item}
          isEdit={true}
        />
      </div>
      {item?.callnotes?.length > 0 && (
        <div className={styles.callNotes}>
          <img src="/images/note-icon.svg" alt="" />
          <div className={styles.text}>{item?.callnotes}</div>
          <img
            src="/images/note-lines.svg"
            alt=""
            className={styles.notesLines}
          />
        </div>
      )}
    </div>
  );
}
